import { cookie } from '@sfe/bone-cache';
import { message } from '@bfe/lux';
import { TOKEN_COOKIE_KEY } from '@bfe/by-dynamic-domain';

import { COOKIE_MAIN_DOMAIN } from './config/env';
import { isApp } from './browser';
import { loadJsHecateScript } from './jsBridge';

let token = '';

export const getUserToken = async () => {
  if (isApp()) {
    if (!token) {
      await loadJsHecateScript();
      return new Promise((resolve) => {
        (window as any)?.BybitHecate?.module('UserProfile')
          .method('getUserProfile')
          .invoke({ needLogin: false })
          .then((res: any) => {
            token = res.params ? res.params.userToken || '' : '';
            resolve(token);
          })
          .catch(({ message: msg }: { message: string }) => {
            message.error(msg);
            token = '';
            resolve(token);
          });
      });
    }
    return Promise.resolve(token);
  } else {
    return Promise.resolve(cookie.get(TOKEN_COOKIE_KEY));
  }
};

export const setToken = (value: string) => {
  cookie.set(TOKEN_COOKIE_KEY, value, {
    expires: 7, // 7天
    domain: COOKIE_MAIN_DOMAIN,
    secure: false, // 集团没有使用 HTTPS Cookie
  });
};

export const removeToken = () => {
  cookie.removeForce(TOKEN_COOKIE_KEY);

  try {
    // if (window.sfe.isApp) {
    //   cookie.remove(TOKEN_COOKIE_KEY, {
    //     path: '/',
    //     domain: `.${window.location.host}`,
    //   });
    //   cookie.remove(TOKEN_COOKIE_KEY, {
    //     path: '/',
    //     domain: window.location.host,
    //   });
    //   token = '';
    // }
  } catch (e) {} // eslint-disable-line
};
